import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bff8962a"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=bff8962a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports